<template>
  <div class="bg-grey-lightest">
    <div class="main-content flex flex-row">
      <div class="main-content-wrap">
        <div class="main-content-pannel flex relative">
          <GmapMap
            ref="myMarker"
            map-type-id="roadmap"
            allowfullscreen
            class="consultant-map-body"
            :center="gmCenter"
            :zoom="gmZoom"
          >
            <gmap-info-window
              :options="infoOptions"
              :position="infoWindowPos"
              :opened="infoWinOpen"
              @closeclick="infoWinOpen=false"
            >{{infoContent}}</gmap-info-window>
            <GmapMarker
              :key="index"
              v-for="(m, index) in gmMarkers"
              :position="m.position"
              :icon="m.icon"
              :clickable="true"
              :draggable="false"
              @click="toggleInfoWindow(m, index)"
            />
          </GmapMap>
          <div class="map-select-layout-active map-select-layout-active-public flex">
            <div class="map-tech-level-selector">
              <model-select
                class="map-tech-level-selector-height"
                :options="techLevelOptions"
                placeholder="Tech Level"
                v-model="selectedTechLevel"
              ></model-select>
            </div>
          </div>
        </div>
        <transition name="edit-pannel">
          <edit-pannel v-model="editOpen" title>
            <PanelConsultantMap
              v-if="editOpen == 1"
              :id="consultantId"
              :name="consultantName"
              :isActive="consultantIsActive"
              :address="consultantAddress"
              :metro="consultantMetro"
              :tools="consultantTools"
              :bio="consultantBio"
              :photo="consultantPhoto"
              :anonymous="type !== 'allinfo'"
              :techLevel="consultantTechLevel"
            ></PanelConsultantMap>
          </edit-pannel>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "@/vendor/firebase";
import EditPannel from "@/components/EditPannel.vue";
import PanelConsultantMap from "@/components/public/PanelConsultantMap.vue";
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";

export default {
  components: {
    EditPannel,
    PanelConsultantMap,
    ModelSelect
  },
  data() {
    return {
      type: null,
      consultants: null,
      gmMarkers: null,

      infoContent: [],
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },

      editOpen: null,
      consultantId: null,
      consultantName: null,
      consultantIsActive: null,
      consultantAddress: null,
      consultantMetro: null,
      consultantTools: null,
      consultantBio: null,
      consultantPhoto: null,
      consultantTechLevel: null,

      gmZoom: 5,
      gmCenter: { lat: 38, lng: -96 },

      techLevels: null,
      techLevelOptions: [],
      selectedTechLevel: "All"
    };
  },
  watch: {
    consultants: function() {
      this.updateMapConsultants();
    },
    techLevels: function() {
      this.updateTechLevel();
    },
    selectedTechLevel: function() {
      this.updateMapConsultants();
    }
  },
  beforeMount() {
    this.$bind("consultants", db.collection("consultants"));
    this.$bind("techLevels", db.collection("tech_levels"));
  },
  mounted() {
    this.type = this.$route.params.type ? this.$route.params.type : "anon";
  },
  methods: {
    updateTechLevel: function() {
      this.techLevelOptions = [];
      for (const index in this.techLevels) {
        this.techLevelOptions.push({
          text: this.techLevels[index].name,
          value: this.techLevels[index].name
        });
      }
      this.techLevelOptions.push({
        text: "All",
        value: "All"
      });
      this.techLevelOptions.push({
        text: "null",
        value: null
      });
      this.techLevelOptions.sort((a, b) => {
        if (a.order === null || a.order === undefined) return 1;
        if (b.order === null || b.order === undefined) return -1;
        return a.order - b.order;
      });
    },
    updateMapConsultants: function() {
      if (this.consultants) {
        this.gmMarkers = [];
        for (const i in this.consultants) {
          const consultant = this.consultants[i];
          if (
            consultant.is_active &&
            consultant.lat_lng &&
            (this.selectedTechLevel == "All" ||
              this.selectedTechLevel == consultant.tech_level)
          ) {
            this.gmMarkers.push({
              position: {
                lat: consultant.lat_lng.lat,
                lng: consultant.lat_lng.lng
              },
              infoText:
                "consultant" + (consultant.name ? ": " + consultant.name : ""),
              consultant: consultant.id,
              icon: { url: require("../../assets/image/ico_consultant.png") }
            });
          }
        }
      }
    },
    toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent =
        this.type == "allinfo" ? marker.infoText : "consultant: Anonymous";
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.editOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
      this.showConsultantPannel(marker.consultant);
    },
    showConsultantPannel: function(id) {
      this.consultants.forEach(item => {
        if (item.id == id) {
          if (this.consultantId != id) {
            this.closeEditPannel();
          }
          this.consultantId = id;
          this.consultantName = item.name ? item.name : "";
          this.consultantIsActive = item.is_active ? "true" : "false";
          this.consultantAddress = item.address ? item.address : "";
          this.consultantMetro = item.metro ? item.metro : "";
          this.consultantTools = item.resume
            ? item.resume.tools
              ? item.resume.tools
              : ""
            : "";
          this.consultantBio = item.bio ? item.bio : "";
          this.consultantPhoto = item.photo_url ? item.photo_url : "";
          this.consultantTechLevel = item.tech_level ? item.tech_level : "";
          this.openEditPannel(1, true);
          return;
        }
      });
    },
    openEditPannel: function(action, isToggle) {
      if (this.editOpen && this.editOpen != action) {
        this.editOpen = action;
        return;
      }
      if (isToggle) {
        this.editOpen = this.editOpen ? false : action;
      } else {
        this.editOpen = action;
      }
    },
    closeEditPannel: function() {
      this.editOpen = false;
    }
  }
};
</script>